import { GET_ALL_NOTIFICATIONS } from "../notifications/notifications-query";
import { MARK_NOTIFICATION_AS_READ } from "./notification-read.mutation";
import { MarkNotificationAsRead } from "./notification-read.interface";
import { useMutation } from "@apollo/client";

export const useSingleReadnotification = () => {
  const [markSinglReadNotification, { error }] = useMutation<MarkNotificationAsRead>(MARK_NOTIFICATION_AS_READ);

  const readNotification = (notificationId: string) => {
    markSinglReadNotification({
      variables: {
        notificationMessageId: notificationId,
      },
      refetchQueries: [GET_ALL_NOTIFICATIONS],
    });
  };

  return {
    readNotification,
    error,
  };
};
